/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statschoosemetric2Inputs */

const en_statschoosemetric2 = /** @type {(inputs: Statschoosemetric2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose the figure for the chart`)
};

const de_statschoosemetric2 = /** @type {(inputs: Statschoosemetric2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kennzahl für den Verlauf wählen`)
};

/**
* | output |
* | --- |
* | "Choose the figure for the chart" |
*
* @param {Statschoosemetric2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statschoosemetric2 = /** @type {((inputs?: Statschoosemetric2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statschoosemetric2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statschoosemetric2(inputs)
	return de_statschoosemetric2(inputs)
});
export { statschoosemetric2 as "statsChooseMetric" }